import React, {useContext} from 'react';
import {useNavigation} from '@react-navigation/native';

import {FilterButton} from './FilterButton';

import {RecordsFilterContext} from '/context/RecordsFilter';

export const FilterButtonDataLayer = (props: any) => {
  const navigation = useNavigation();

  /* istanbul ignore next */
  // @ts-expect-error TS(2339): Property 'filterParam' does not exist on type 'unk... Remove this comment to see the full error message
  const {filterParams, setSelectedFilterParam} =
    useContext(RecordsFilterContext);

  return (
    // @ts-expect-error TS(2786): 'FilterButton' cannot be used as a JSX component.
    <FilterButton
      navigate={navigation.navigate}
      filterParams={filterParams}
      setSelectedFilterParam={setSelectedFilterParam}
      {...props}
    />
  );
};
